import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Observable, Subscription } from 'rxjs';

import { Dietitian } from '../../../data/dietitian/domain/dietitian';
import {
  MessageTemplate,
  MessageTemplateType,
} from '../../../data/dietitian/domain/message_template/message-template';
import { AccountViewModel } from '../diary/diary/diary.facade';
import { MessageEditorFacade } from './message-editor-facade';
import { BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import * as confirmationModalComponent from '../confirmation-modal/confirmation-modal.component';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-message-editor',
  templateUrl: './message-editor.component.html',
  styleUrls: ['./message-editor.component.scss'],
  providers: [MessageEditorFacade],
})
export class MessageEditorComponent implements OnInit, OnDestroy {
  @Input() visible = false;
  @Input() minRows = 3;
  @Input() maxRows = 10;
  @Input() type: MessageTemplateType = 'other';
  @Output() changeMessageTemplate = new EventEmitter<MessageTemplate>();
  @Output() deleteMessageTemplate = new EventEmitter<MessageTemplate>();
  @Output() invalidMessageTemplate = new EventEmitter<boolean>();

  emptyMessageTemplate: MessageTemplate;
  defaultMessageTemplate: MessageTemplate;
  currentMessageTemplate: MessageTemplate;
  messagesTemplates: MessageTemplate[];
  sign: string | undefined;
  withSign = true;
  private accountStatus$: Observable<AccountViewModel>;
  private accountStatusSubscription: Subscription;
  private dietitian: Dietitian;

  constructor(
    private facade: MessageEditorFacade,
    private modalService: BsModalService,
  ) {
    this.accountStatus$ = this.facade.accountStatus$;

    this.accountStatusSubscription = this.accountStatus$.subscribe((state) => {
      this.dietitian = state.dietitian;
    });
  }

  ngOnDestroy(): void {
    this.accountStatusSubscription?.unsubscribe();
  }

  ngOnInit(): void {
    this.emptyMessageTemplate = this.facade.getEmptyMessageTemplate(
      this.type,
      this.withSign,
    );
    this.defaultMessageTemplate = this.facade.getDefaultMessageTemplate(
      this.type,
      this.withSign,
    );
    this.currentMessageTemplate = this.defaultMessageTemplate;
    this.changeMessageTemplate.emit(this.currentMessageTemplate);
    this.sign = this.facade.getSign(this.dietitian);

    this.facade
      .getAllTemplate(this.dietitian.id.toString(), this.type)
      .then((templates) => (this.messagesTemplates = templates));
  }

  onChangeMessageTemplate(value: MessageTemplate) {
    this.currentMessageTemplate = value;
    this.withSign = value.withSign;
    this.changeMessageTemplate.emit(this.currentMessageTemplate);
    this.invalidMessageTemplate.emit(
      this.currentMessageTemplate.content.length === 0,
    );
  }

  onChangeMessageTemplateContent(content: string, withSign: boolean) {
    this.currentMessageTemplate.content = content;
    this.currentMessageTemplate.withSign = withSign;
    this.invalidMessageTemplate.emit(content.length === 0);
    this.changeMessageTemplate.emit(this.currentMessageTemplate);
  }

  deleteTemplate(template: MessageTemplate) {
    const initialState: ModalOptions = {
      class: 'modal-md modal-dialog-centered',
      initialState: {
        title: 'Suppression...',
        subtitle: 'Voulez-vous vraiment supprimer ce modèle de message ?',
      },
    };
    const confirmModal = this.modalService.show(
      confirmationModalComponent.ConfirmationModalComponent,
      initialState,
    );
    if (
      confirmModal.content instanceof
      confirmationModalComponent.ConfirmationModalComponent
    ) {
      confirmModal.content.validate.subscribe(() => {
        this.deleteMessageTemplate.emit(template);
        this.messagesTemplates.splice(
          this.messagesTemplates.indexOf(template),
          1,
        );
        this.currentMessageTemplate = this.defaultMessageTemplate;
      });
    }
  }
}
